"use client";

import { usePathname as usePathnameOriginal } from "next/navigation";
import { useMemo } from "react";
import { normalizePathname } from "@utils/routeNormalizer";

/**
 * 获取规范化后的 pathname
 * @returns 规范化后的 pathname
 */
export const usePathname = (includeLocale?: boolean): string => {
  const pathnameOrg = usePathnameOriginal();
  const pathname = useMemo(
    () => normalizePathname(pathnameOrg, includeLocale),
    [pathnameOrg, includeLocale],
  );
  return pathname;
};
